import { Col, Row } from 'antd'
import React from 'react'
import CardPackage from '../card/card-package'
import Slider from 'react-slick'

const AvailablePackageSection = () => {
  return (
    <Row className="bg-white w-full py-9 lg:py-20 gap-8">
      <Col span={24} className="text-center">
        <p className="display-xs-semibold xl:display-sm-semibold text-gray-900">Paket Servis</p>
      </Col>
      <Col span={20} className="mx-auto">
        <div className="hidden lg:grid grid-cols-4 gap-6">
          <CardPackage />
          <CardPackage />
          <CardPackage />
          <CardPackage />
        </div>
        <Slider className="lg:hidden" arrows={false} dots slidesToShow={1} infinite autoplay>
          {new Array(6).fill(0).map((review, key) => (
            <div key={key} className="">
              <CardPackage />
            </div>
          ))}
        </Slider>
      </Col>
    </Row>
  )
}

export default AvailablePackageSection
